module.exports = __webpack_public_path__ + "static/media/rivieramaya.1e929a64.jpg";